<template>
    <span>
        ${{getValue}}
    </span>
</template>

<script>
    export default {
        name: "currencyDisplay",
        props: {
            value: {
                required: true
            }
        },
        computed: {
            getValue () {
                if(this.value === 0){
                    return '0.00'
                }
                else if(this.value >= 1000){
                    return this.value.toLocaleString('en-US', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    })
                }

                return this.value.toFixed(2)
            }
        }
    }
</script>

<style scoped>

</style>
